import React from "react"
import Breadcrumb from "../../components/Breadcrumb"
import {observer} from "mobx-react-lite"

const LowHeaderContainer = ({businessName}) => {
  let breadcrumbData = [
    {
      key: "/brands/discovery",
      label: "POI",
      className: "breadcrumb-title",
    },
    {
      key: "/brands/locations",
      label: businessName,
      className: "breadcrumb-subtitle",
    },
  ]

  return (
    <div
      data-testid="lowerheader-container"
      className="poi-lowerheader-container"
      id="lowerheader-container"
    >
      {businessName && <Breadcrumb breadcrumbData={breadcrumbData} />}
    </div>
  )
}
export default observer(LowHeaderContainer)
